export default function AnimatedSandClock() {
  return (
    <div className="relative mx-auto h-32 w-32">
      <div className="absolute inset-0">
        <svg
          width="128"
          height="128"
          viewBox="0 0 128 128"
          className="h-full w-full"
        >
          <HourglassFrame />
          <TopSand />
          <BottomSand />
          <SandStream />
          <SandParticles />
          <SandGlow />
        </svg>
      </div>

      <div className="bg-gradient-radial from-primary-extra-light animate-pulse-slow absolute inset-0 rounded-full via-transparent to-transparent opacity-30"></div>
    </div>
  );
}

// 🔽 Subcomponents below

function HourglassFrame() {
  return (
    <path
      d="M24 12 L104 12 L104 28 L64 64 L104 100 L104 116 L24 116 L24 100 L64 64 L24 28 Z"
      fill="none"
      stroke="#1c4130"
      strokeWidth="4"
      className="drop-shadow-lg"
    />
  );
}

function TopSand() {
  return (
    <>
      <defs>
        <clipPath id="topSand">
          <path d="M28 16 L100 16 L100 26 L64 60 L28 26 Z" />
        </clipPath>
      </defs>
      <rect
        x="28"
        y="16"
        width="72"
        height="44"
        fill="#5ab261"
        clipPath="url(#topSand)"
        className="animate-sand-fall"
      />
    </>
  );
}

function BottomSand() {
  return (
    <>
      <defs>
        <clipPath id="bottomSand">
          <path d="M28 102 L100 102 L100 112 L28 112 Z" />
        </clipPath>
      </defs>
      <rect
        x="28"
        y="102"
        width="72"
        height="10"
        fill="#2d6944"
        clipPath="url(#bottomSand)"
        className="animate-sand-collect"
      />
    </>
  );
}

function SandStream() {
  return (
    <line
      x1="64"
      y1="58"
      x2="64"
      y2="70"
      stroke="#5ab261"
      strokeWidth="2"
      opacity="0.8"
      className="animate-sand-stream"
    />
  );
}

function SandParticles() {
  return (
    <>
      <circle
        cx="64"
        cy="62"
        r="1.5"
        fill="#5ab261"
        className="animate-sand-drop"
      />
      <circle
        cx="63"
        cy="66"
        r="1.2"
        fill="#2d6944"
        className="animate-sand-drop-delayed"
      />
      <circle
        cx="65"
        cy="64"
        r="1"
        fill="#5ab261"
        className="animate-sand-drop-delayed-2"
      />
      <circle
        cx="64"
        cy="68"
        r="0.8"
        fill="#2d6944"
        className="animate-sand-drop-delayed-3"
      />
    </>
  );
}

function SandGlow() {
  return (
    <ellipse
      cx="64"
      cy="102"
      rx="36"
      ry="3"
      fill="#ddf3d9"
      opacity="0.6"
      className="animate-sand-glow"
    />
  );
}
